import OneSignalShopifySDK from './OneSignalShopifySDK';
import Log from './Log';

/**
 * This library will self initialize.  It does so by simply calling the OneSignalShopify.initialize method.
 * 
 * The argument provided in the OneSignalShopify.initialize method will end up getting replaced by turbine
 * on the server when this library is being served.  The flow of this looks something like the following:
 * 
 * A reference to this library is added to the Shopify store by creating a ScriptTag reference:
 * https://shopify.dev/docs/admin-api/rest/reference/online-store/scripttag
 * 
 * The URL will look something like the following:
 * https://onesignal.com/sdks/shopify/:app_id/OneSignalShopify.js
 * 
 * Turbine will take the :app_id portion of the request URL and replace the `cb0d3c1a-6fa7-43e2-ad8e-026883761736` string
 * with that value.
 * 
 * Finally, the script is requested through CloudFlare (before hitting our servers) which will cache the response
 * based on whatever the cache headers and the CloudFlare configuration is.
 */
(function(): void {
  try {
    // cb0d3c1a-6fa7-43e2-ad8e-026883761736 is replaced by turbine when serving this library.
    OneSignalShopifySDK.initialize("cb0d3c1a-6fa7-43e2-ad8e-026883761736");
  } catch (e) {
    Log.error("Failed to initialize OneSignal Shopify SDK.", e);
  }
})();


export default OneSignalShopifySDK;
